import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import YouTube from 'react-youtube';

import S from './styles';

const youtubeOptions = {
  playerVars: {
    rel: 0,
    showinfo: 0,
    autoplay: 1,
  },
};

const renderYoutubePlayer = (link) => {
  const videoId = link.replace('https://youtu.be/', '');
  return (
    <S.VideoPlayerWrapper isYouTube>
      <YouTube
        videoId={videoId}
        id="player"
        opts={youtubeOptions}
        autoplay
      />
    </S.VideoPlayerWrapper>
  );
};

const renderDefaultPlayer = ({ video: { desktop, mobile }, picture }, screenType) => {
  const src = screenType !== 'mobile' && desktop ? desktop : mobile;
  const [canPlay, setCanPlay] = useState(false);

  return (
    <S.VideoPlayerWrapper canPlay={canPlay}>
      <video
        autoPlay
        muted={false}
        controls
        poster={picture}
        onCanPlay={() => setCanPlay(true)}
      >
        <source src={src} type="video/mp4" />
      </video>
    </S.VideoPlayerWrapper>
  );
};

const renderVideoPLayer = (video, screenType) => {
  const { video: { youtube } } = video;

  if (youtube) {
    return renderYoutubePlayer(youtube);
  }

  return renderDefaultPlayer(video, screenType);
};

const VideoModal = ({
  video, screenType,
}) => (
  <S.Wrapper>
    {!!video && renderVideoPLayer(video, screenType)}
  </S.Wrapper>
);

VideoModal.propTypes = {
  video: PropTypes.shape({}),
  screenType: PropTypes.string.isRequired,
};

VideoModal.defaultProps = {
  video: null,
};

const mapStateToProps = ({ appClientService }) => ({
  screenType: appClientService.screenType,
});

export default connect(mapStateToProps)(VideoModal);
